export function isTemplatesEnabled() {
  return process.env.BUN_PUBLIC_DISABLE_TEMPLATES !== 'true';
}
